function TheraText() {
  return <h2>TheraText Page</h2>;
}
export default TheraText;
